import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSquareRootAlt, faAtom, faBook, faLandmark, faVolleyballBall,
  faWrench, faMusic, faPaintBrush, faAtlas, faDna, faFlask,
  faDesktop, faHistory,
} from '@fortawesome/free-solid-svg-icons';

const specIds = new Set([
  '1','2','3','5','7','8','9','13','99','101',
  '802','2323','2324','2330','2331','2332','8030',
]);

const iconMap = {
  1: faSquareRootAlt, 2: faAtom, 5: faBook, 7: faLandmark,
  99: faVolleyballBall, 802: faWrench, 2330: faWrench,
  2324: faMusic, 2323: faPaintBrush, 2331: faPaintBrush,
  101: faAtlas, 2332: faDna, 8: faDna, 3: faFlask,
  9: faDesktop, 8030: faDesktop, 13: faHistory,
};

export default function SubjectIcon({ naziv, id }) {
  const isSpec = specIds.has(String(id));
  return (
    <div className="icon-container">
      <div className="icon-style">
        {isSpec && iconMap[id]
          ? <FontAwesomeIcon icon={iconMap[id]} size="1x" />
          : naziv?.substring(0, 1).toUpperCase()}
      </div>
    </div>
  );
}
